// Number on client side, string on server side.

export default {
  serialize(value) {
    return value === null || value === undefined ? undefined : value.toString();
  },
  deserialize(value) {
    if (value === null || value === undefined) {
      return null;
    }
    return Number(value);
  }
};